<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_LINK_STT')" />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectLinkStateCode"
              v-model="queryData.linkStateCode"
              codeId="COD_LINK_STT"
              :defaultOption="'all'"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_USE_YN')" />
          </div>
          <div class="col-xs-5">
            <sui-yn-select
              ref="ynSelectLinkUseYn"
              v-model="queryData.linkUseYn"
              :defaultOption="'all'"
            />
          </div>
        </div>
        <div class="row">
          <div
            v-if="deviceApplyYn"
            class="col-xs-1"
          >
            <sui-input-label
              :label="$t('MSG_TXT_DVC_TYPE')"
              :required="false"
              :vertical="false"
            />
          </div>
          <div
            v-if="deviceApplyYn"
            class="col-xs-5"
          >
            <sui-multi-select
              ref="deviceMultiDropdown"
              v-model="deviceSelectValue"
              :placeholder="placeholder"
              :options="deviceTypeList"
              :multiple="true"
              :closeOnSelect="false"
              :useAllOption="true"
            />
            <!-- <ur-multi-dropdown
              ref="deviceMultiDropdown"
              :items="deviceTypeList"
            /> -->
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_SEARCH_COND')" />
          </div>
          <div class="col-xs-5">
            <sui-code-select
              ref="codeSelectSearchCondition"
              v-model="queryData.searchCondition"
              codeId="COD_LINK_SEARCH_COND"
              :defaultOption="'all'"
              style="width:58%"
            />
            <div class="comp_spacing" />
            <sui-text-field
              v-model="queryData.searchWord"
              maxlength="50"
              @keyup.enter="onClickSearch"
            />
          </div>
          <div
            v-if="!deviceApplyYn"
            class="col-xs-1 nodata"
          />
          <div
            v-if="!deviceApplyYn"
            class="col-xs-5 nodata"
          />
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t("MSG_BTN_SRCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <ur-data-grid
        ref="gridLink"
        :headers="columnLink"
        :data-source="dsLink"
        :options="options"
        @grid:row-click="onSelectRow"
      >
        <template #left-info>
          <ur-dropdown
            v-model="rowsPerPage"
            class="ur-data-grid__info__per-page"
            :items="perPageItems"
            @input="onChangePageSize"
          />
        </template>
        <template #right-info>
          <sui-button
            class="comm_btn_gridTop comm_ico_excel"
            @click="onClickExcelDownload"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>          
        </template>
      </ur-data-grid>
      <div class="mrB30" />
      <sui-page-tab-box-type
        ref="tab"
        :tabItems="tabItems"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="onSetCurrentTabComponent"
        @change-tab-idx="onChangeTabIdx"
      >
        <container
          :is="currentTabComponent"
          :selectedGridRowData="selectedGridRowData"
          :deviceApplyYn="deviceApplyYn"
          @onClickSearch="onClickSearch"
        />
      </sui-page-tab-box-type>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import {urDataSet} from 'uidev-component/index.js';
import BasePage from '~cm/components/BasePage';
import tab01 from './components/PGE_CMP_00027_T01.vue';
import tab02 from './components/PGE_CMP_00027_T02.vue';
import tab03 from './components/PGE_CMP_00027_T03.vue';
import urDataGrid from '@uidev/grid/urDataGrid/urDataGrid';

const DEFAULT_ROWS_PER_PAGE = 5;
const DEFAULT_ROW_HEIGHT = 55;


export default {
  name: 'PGE_CMP_00027', // eslint-disable-line vue/name-property-casing
  components: {
    tab01,
    tab02,
    tab03,
    urDataGrid,
  }, 
  extends: BasePage,
  data() {
    return {
      deviceApplyYn: utils.getConfigurationValue('CFG_CMZ_DVC_TYPE_APPY_YN') === 'Y',
      dsLink: new urDataSet(),
      options: {
        infinityScroll: true,
        noBaseInfo: false,
        internalPaging: false,
        height: DEFAULT_ROWS_PER_PAGE * DEFAULT_ROW_HEIGHT,
      },
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      selectedGridRowData: {},
      tabItems: [
        {
          tabTitle: this.$t("MSG_TXT_LINK"),
          component: tab01,
        },
        {
          tabTitle: this.$t("MSG_TXT_PRMT"),
          component: tab02,
        },
        {
          tabTitle: this.$t("MSG_TXT_ROLE"),
          component: tab03,
        },

      ],
      currentTabComponent: 'tab01',
      defaultTabIndex: 0,
      queryData: {
        linkName: '',
        linkStateCode: '',
        linkUseYn: '',
        deviceTypeBit: '',
        searchCondition: '',
        searchWord: '',
      },
      deviceSelectValue: [],
      placeholder: this.$t('MSG_TXT_ALL'),
    };
  },
  computed: {
  },
  watch: {},
  created() {
    this.deviceTypeList = [];
    this.perPageItems = [
      { value: 5, text: '5 per page' },
      { value: 10, text: '10 per page' },
      { value: 15, text: '15 per page' },
    ];
    this.columnLink = [
      {
        value: 'linkId',
        text: this.$t('MSG_TXT_LINK_ID'),
        width: 250,
      },
      {
        value: 'linkName',
        text: this.$t('MSG_TXT_LINK_NM'),
        width: 250,
      },
      {
        value: 'linkUrl',
        text: this.$t('MSG_TXT_LINK_URL'),
      },
      {
        value: 'linkStateName',
        text: this.$t('MSG_TXT_LINK_STT'),
        width: 150,
      },
      {
        value: 'linkUseYn',
        text: this.$t('MSG_TXT_USE_YN'),
        width: 80,
      },
      {
        text: this.$t('MSG_TXT_DVC_TYPE'),
        value: 'deviceTypeName',
        hidden: !this.deviceApplyYn,
        width: 120,
      },
      {
        value: 'm_userName',
        text: this.$t('MSG_TXT_MDFC_USR'),
        width: 200,
        component: {
          props: ['row', 'value'],
          template:
            `<cmp-user-name-link
              :pageId="'PGE_CMP_00027'"
              :displayType="'1'"
              :displayLanguageId="row.m_dsplLngId"
              :userId="row.m_userId"
              :knoxId="row.m_knoxId"
              :loginId="row.m_loginId"
              :userName="row.m_userName"
              :userGlobalName="row.m_userGlobalName"
              :departmentName="row.m_departmentName"
              :departmentEnglishName="row.m_departmentEnglishName"
              :type="'link'"
            />`,
        },
      },
      {
        value: 'finalModificationDTM',
        text: this.$t('MSG_TXT_MDFC_DTM'),
        width: 150,
        customValue(value, row) {
          return utils.dateformatToClient(value);
        },
      },
    ];
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
      this.loadDeviceCode();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      const paramData = utils.getParameter(this, 'queryData');
      if (!utils.isEmpty(paramData)) {
        this.queryData = paramData;
        this.onClickSearch();
      }
    },
    loadDeviceCode() {
      http.getCodeList(this.pageId, ['COD_DVC_TYPE'], '').then(res => {
        utils.forEach(res['COD_DVC_TYPE'], (value, key) => {
          this.deviceTypeList.push(
            // { value: value.key, text: value.codeName }
            { key: value.key, label: value.codeName },
          );
          this.deviceSelectValue.push(
            { key: value.key, label: value.codeName },
          );
        });
      }).catch(err => {
        console.log(err);
      });
    },
    onClickSearch() {
      if (this.deviceApplyYn) {
        this.queryData.deviceTypeBit = this.calculateDeviceTypeBit();
      }

      const dataParams = {
        linkStateCode: this.queryData.linkStateCode,
        linkUseYn: this.queryData.linkUseYn,
        searchCondition: this.queryData.searchCondition,
        searchWord: this.queryData.searchWord,
        deviceTypeBit: this.queryData.deviceTypeBit ? this.queryData.deviceTypeBit : 0,
      };
      http.request(this.contextPageId, 'DTS_CMP_00109', {
        query: dataParams,
      }).then(res => {
        this.setUserInfoFormat(res.data);
        this.dsLink.setData(res.data);
      });
    },
    onClickReset() {
      this.queryData.searchWord = '';
      this.$refs.codeSelectLinkStateCode.reset();
      this.$refs.ynSelectLinkUseYn.reset();
      this.$refs.codeSelectSearchCondition.reset();

      if (this.deviceApplyYn) {
        // this.$refs.deviceMultiDropdown.selected = [];
        this.deviceSelectValue = [];
      }

    },
    onSetCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].component;
    },
    onClickExcelDownload() {
      const sPageId = this.contextPageId;
      const objGridColumns = this.columnLink;
      const objGridDataset = this.dsLink;
      const sToday = utils.now('YYYYMMDDHHmmss');
      const sExcelName = `link_management_${sToday}.xlsx`;
      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName, {});
    },
    onSelectRow(row) {
      if (row) {
        this.selectedGridRowData = row;
      }
    },
    onChangePageSize(v) {
      this.$refs.gridLink.mx_pager.rowsPerPage = v;
      this.options.height = v * DEFAULT_ROW_HEIGHT;
      this.$nextTick(() => {
        this.$refs.gridLink.mx_buildViewData();
      });
    },
    calculateDeviceTypeBit() {
      let ret = 0;
      // const deviceSelectedList = this.$refs.deviceMultiDropdown.selected;
      // utils.forEach(deviceSelectedList, (item, key) => {
      // ret += Number(item.value);
      utils.forEach(this.deviceSelectValue, (item, key) => {
        ret += Number(item.key);
      });
      return ret;
    },
    setUserInfoFormat(list) {
      utils.forEach(list, data => {
        utils.forEach(data.firstRegistrationUserInfo, (value, key) => {
          utils.set(data, `r_${key}`, value);
        });
        utils.forEach(data.finalModificationUserInfo, (value, key) => {
          utils.set(data, `m_${key}`, value);
        });
      });
      return list;
    },
  },
};
</script>

<style scoped>
</style>
